// views/auth/register.js  (IT)
export const register_i18n = {
  alts: { banner: "sfondo di registrazione", brand: "WA Checkin", footerLogo: "WA Checkin" },
  aria: { toggleReferral: "attiva o disattiva il codice affiliato", togglePassword: "mostra o nascondi la password" },
  texts: {
    inviteTitle: "Congratulazioni!",
    inviteText: "{name} ti ha invitato su WACheckin: hai il {percent}% di sconto sui primi {months} mesi.",
    inviteApplied: "Applicato dal tuo link di invito.",
    panelKicker: "WACHECKIN · 2026",
    panelCta: "Scopri WACheckin",
    langLabel: "Lingua",
    panelTitle: "Configuralo una volta. Il resto va da sé.",
    panelDesc:
      "Il link del check-in, il benvenuto, le chiavi e la comunicazione alle autorità partono senza che tu debba ricordartene.",
    title: "Crea il tuo account",
    infoTitle: "Registrati in pochi minuti",
    infoDesc:
      "Completa i tuoi dati e inizia ad automatizzare il check-in e la comunicazione con i tuoi ospiti.",
    referralHint: "Attivalo solo se te ne hanno dato uno.",
    alreadyHaveAccount: "Hai già un account?",
  },
  labels: {
    inviteCode: "Codice di invito",
    name: "Nome",
    email: "Email",
    password: "Password",
    phone: "Telefono",
    referralCode: "Codice affiliato",
  },
  placeholders: {
    name: "Inserisci il tuo nome",
    email: "Inserisci la tua email",
    password: "Crea una password",
    referralCode: "Codice",
  },
  buttons: { submit: "Crea account", submitting: "Creazione account...", signIn: "Accedi" },
  validation: { phoneRequired: "Scrivi il tuo numero, non solo il prefisso.", phoneInvalid: "Questo numero non è valido. Controllalo.", invalidReferralCode: "Il codice affiliato non è valido." },
  toast: {
    signupSuccess: "Account creato con successo!",
    signupError: "Errore durante la registrazione.",
    networkError: "Errore di connessione. Riprova.",
    referralCodeError: "Il codice affiliato non è valido.",
  },
};
